import React, { useEffect, useRef } from "react";
import { Container, Row, Col, Button } from "reactstrap";

import videoSrc from "assets/img/demo.mp4"; // Replace with your video path

const Contact = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.play().catch(error => {
        console.log('Autoplay failed:', error);
      });
    }
  }, []);

  return (
    <>
      <div className="main">
        <div className="section section-maglev-blue text-center" style={{ position: 'relative', overflow: 'hidden' }}>
          <video
          ref={videoRef}
            autoPlay
            loop
            muted
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              zIndex: -1
            }}
          >
            <source src={videoSrc} type="video/mp4" />
          </video>
          <div
            className="filter"
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0, 0, 0, 0.5)', // Dark overlay for readability
              zIndex: 0
            }}
          ></div>
          <Container style={{ position: 'relative', zIndex: 1 }}>
            <Row className="justify-content-center">
              <Col md="8">
                <h1 className="title" style={{ color: 'white' }}>Contact</h1>
                <p className="description" style={{ color: 'white' }}>
                  Based in Boston. Contact us today.
                </p>
                <Button color="primary" size="lg" className="btn-round" href="mailto:contact@maglevaero.com">
                  Contact Us
                </Button>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
}

export default Contact;